import { render } from "./List.vue?vue&type=template&id=f1563d1e&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=f1563d1e&scoped=true&lang=less"

import exportComponent from "E:\\Samples\\学习\\WebPackTest\\my-diary\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1563d1e"]])

export default __exports__